import {
  // SET_STATISTICS_LIST,
  SET_STATISTICS_SEARCHING,
} from './mutation-types.js'
import api from '@/api'

const state = {
  searching: false,
  // list: [],
}

const mutations = {
  // [SET_STATISTICS_LIST] (state, payload) {
  //   state.list = payload
  // },
  [SET_STATISTICS_SEARCHING] (state, payload) {
    state.searching = payload
  },
}

const actions = {
  async getStatisticsList ({commit, state}, payload) {
    try {
      commit(SET_STATISTICS_SEARCHING, true)
      let {data} = await api.monitorApi.getRegisterSourceStatistics(payload)
      commit(SET_STATISTICS_SEARCHING, false)
      return data
    } catch (error) {
      commit(SET_STATISTICS_SEARCHING, false)
    }
  },
  async getCopyrightStatisticsList ({commit, state}, payload) {
    try {
      commit(SET_STATISTICS_SEARCHING, true)
      let {data} = await api.monitorApi.getCopyRightRegisterSourceStatistics(payload)
      commit(SET_STATISTICS_SEARCHING, false)
      return data
    } catch (error) {
      commit(SET_STATISTICS_SEARCHING, false)
    }
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
